export default __webpack_public_path__ + "static/media/1069.77305878.png";